import { render } from "./StatisticsByTimeTabs.vue?vue&type=template&id=33658a55&ts=true"
import script from "./StatisticsByTimeTabs.vue?vue&type=script&lang=ts"
export * from "./StatisticsByTimeTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__